import { scrollTo } from '@helpers/scrollTo';
import { ReactComponent as SvgChevronDown } from '@img/icons/chevron-down.svg';
import { ReactComponent as SvgChevronRight } from '@img/icons/chevron-right.svg';
import React from 'react';
import S from './QuickLinks.styles';
const QuickLinks = ({ items, title }) => {
    return (React.createElement(S.Container, { "aria-label": title ?? 'Quick Links' },
        title && React.createElement(S.Title, null, title),
        React.createElement(S.List, null, items.map((item) => (React.createElement(S.Item, { key: item.id },
            React.createElement(S.Link, { href: item.url ?? item.anchor, target: item.target, onClick: (event) => {
                    if (!item.url && item.anchor) {
                        event.preventDefault();
                        scrollTo(item.anchor);
                    }
                    if (item.url && item.url[0] === '#') {
                        event.preventDefault();
                        scrollTo(item.url);
                    }
                } },
                React.createElement(S.Icon, { as: item.anchor ? SvgChevronDown : SvgChevronRight }),
                React.createElement(S.Text, null, item.text))))))));
};
export default QuickLinks;
